enum carrierCode {
    AC = 'AC',
    AA = 'AA',
    NZ = 'NZ',
    MH = 'MH',
    UA = 'UA',
    AFKL = 'AF-KL',
    AF = 'AF',
    KL = 'KL',
    SK = 'SK',
    UW = 'UW',
    AI = 'AI',
    AZ = 'AZ',
    QR = 'QR',
    EightD = '8D'
}

export interface ICarrierAdminUserManagementAuthorizationConfig {
    isManageMyProfile: string
    isManageBranchAccess: string
    isManageCarrierProfile: string
    isManageCarrierUsers: string
    isCreateCarrierUser: string
}

export interface ICarrierAdminLevelsConfig {
    isCarrierAdmin: boolean
    isSecondLevelCarrierAdmin: boolean
}

export const CarrierAdminUserManagementPrevilages = () => {
    const ACCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const AACarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const NZCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const MHCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const UACarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const AFKLCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const SKCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Disabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const UWCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const AICarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const AZCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const QRCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const EightDCarrierAdmin: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const adminHashMap = new Map<string, ICarrierAdminUserManagementAuthorizationConfig>()
        .set(carrierCode.AC, ACCarrierAdmin)
        .set(carrierCode.AA, AACarrierAdmin)
        .set(carrierCode.NZ, NZCarrierAdmin)
        .set(carrierCode.MH, MHCarrierAdmin)
        .set(carrierCode.UA, UACarrierAdmin)
        .set(carrierCode.AFKL, AFKLCarrierAdmin)
        .set(carrierCode.AF, AFKLCarrierAdmin)
        .set(carrierCode.KL, AFKLCarrierAdmin)
        .set(carrierCode.SK, SKCarrierAdmin)
        .set(carrierCode.UW, UWCarrierAdmin)
        .set(carrierCode.AI, AICarrierAdmin)
        .set(carrierCode.AZ, AZCarrierAdmin)
        .set(carrierCode.QR, QRCarrierAdmin)
        .set(carrierCode.EightD, EightDCarrierAdmin)

    return adminHashMap
}

export const CarrierAdminUserManagementAccess = () => {
    const carrierAdminConfigKey1: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: true,
        isSecondLevelCarrierAdmin: true
    }

    const carrierAdminConfigValue1: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Enabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const carrierAdminConfigKey2: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: true,
        isSecondLevelCarrierAdmin: false
    }

    const carrierAdminConfigValue2: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Enabled',
        isManageCarrierProfile: 'Disabled',
        isManageCarrierUsers: 'Disabled',
        isCreateCarrierUser: 'Disabled'
    }

    const carrierAdminConfigKey3: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: false,
        isSecondLevelCarrierAdmin: true
    }

    const carrierAdminConfigValue3: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Disabled',
        isManageCarrierProfile: 'Disabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const carrierAdminConfigKey4: ICarrierAdminLevelsConfig = {
        isCarrierAdmin: false,
        isSecondLevelCarrierAdmin: false
    }

    const carrierAdminConfigValue4: ICarrierAdminUserManagementAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchAccess: 'Disabled',
        isManageCarrierProfile: 'Disabled',
        isManageCarrierUsers: 'Enabled',
        isCreateCarrierUser: 'Enabled'
    }

    const adminHashMap = new Map<ICarrierAdminLevelsConfig, ICarrierAdminUserManagementAuthorizationConfig>()
    adminHashMap.set(carrierAdminConfigKey1, carrierAdminConfigValue1)
    adminHashMap.set(carrierAdminConfigKey2, carrierAdminConfigValue2)
    adminHashMap.set(carrierAdminConfigKey3, carrierAdminConfigValue3)
    adminHashMap.set(carrierAdminConfigKey4, carrierAdminConfigValue4)

    return adminHashMap
}

export const deafultCarrierUserManagementPrevilages: ICarrierAdminUserManagementAuthorizationConfig = {
    isManageMyProfile: 'Disabled',
    isManageBranchAccess: 'Disabled',
    isManageCarrierProfile: 'Disabled',
    isManageCarrierUsers: 'Disabled',
    isCreateCarrierUser: 'Disabled'
}
